export const authorSuggestions = [
  { xpath: '//div[@class="author"]' },
  { xpath: 'xpath:(//div[@class="author"])[1]' },
  { xpath: 'xpath://a[@rel="author"]' },
  { xpath: "xpath://div[contains(text(), 'By')]" },
  { xpath: "xpath://div[contains(@class, 'Byline')]" },
  { xpath: "xpath:(//div[contains(@class, 'Byline')])[1]" },
  { xpath: "xpath://p/strong" },
  { xpath: 'xpath://a[@rel="author"]|//p/strong' },
];

export const webCrawlerContainerSuggestions = [
  { xpath: '//div[@class="author"]' },
  { xpath: '(//div[@class="author"])[1]' },
  { xpath: '//a[@rel="author"]' },
  { xpath: "//div[contains(text(), 'By')]" },
  { xpath: "//div[contains(@class, 'Byline')]" },
  { xpath: "(//div[contains(@class, 'Byline')])[1]" },
  { xpath: "//p/strong" },
  { xpath: '//a[@rel="author"]|//p/strong' },
];

export const nextPageSuggestions = [
  { xpath: 'click://a[@class="next"]' },
  { xpath: 'click://a[text()="Next"]' },
  { xpath: "click://a[contains(text(), 'Next')]" },
  { xpath: "click://button[text() = 'Older posts']" },
  { xpath: "click://span[contains(@class, 'is-active')]/following-sibling::a" },
  { xpath: 'click:(//a[text()="Next"])[1]' },
];

export const webCrawlernextPageSuggestions = [
  { xpath: '//a[@class="next"]' },
  { xpath: '//a[text()="Next"]' },
  { xpath: "//a[contains(text(), 'Next')]" },
  { xpath: "//button[text() = 'Older posts']" },
  { xpath: "//span[contains(@class, 'is-active')]/following-sibling::a" },
  { xpath: '(//a[text()="Next"])[1]' },
];

export const otherSuggestions = [
  { xpath: 'click://a[@class="next"]' },
  { xpath: 'click://a[text()="Next"]' },
  { xpath: "click://a[contains(text(), 'Next')]" },
  { xpath: "click://button[text() = 'Older posts']" },
];

export const loadMoreSugestions = [
  { xpath: 'click://a[@class="next"]' },
  { xpath: 'click://a[text()="Load more"]' },
  { xpath: "click://a[contains(text(), 'Load more')]" },
  { xpath: "click://button[text() = 'Older posts']" },
  { xpath: "click://span[contains(@class, 'is-active')]/following-sibling::a" },
  { xpath: 'click:(//a[text()="Next"])[1]' },
  { xpath: "scroll" },
  { xpath: "scrollthenclick://a[contains(text(), 'View more')]" },
];

export const stepSleepOptions = [6000, 1000, 100, 0];

export const sourceColors = [
  "#08d9d6",
  "#fce38a",
  "#fc5185",
  "#8785a2",
  "#00b8a9",
  "#2b2e4a",
  "#ffc8c8",
  "#a2d5f2",
  "#930077",
  "#fff5a5",
  "#455d7a",
  "#005792",
  "#c86b85",
  "#a7ff83",
  "#00ad7c",
  "#18587a",
  "#ffd2a5",
  "#7393a7",
  "#bc5148",
  "#0f1021",
  "#FDF5E6",
  "#FF69B4",
  "#9932CC",
  "#00FA9A",
  "#DA70D6",
  "#DDA0DD",
  "#66CDAA",
  "#006400",
  "#8FBC8F",
  "#FFA07A",
  "#8B4513",
  "#D2B48C",
  "#7FFF00",
  "#40E0D0",
  "#F5F5DC",
  "#9966CC",
  "#B22222",
  "#FFFF00",
  "#E6E6FA",
  "#FFA07A",
  "#E0FFFF",
  "#3CB371",
  "#191970",
  "#48D1CC",
  "#5F9EA0",
  "#808080",
  "#87CEEB",
  "#8A2BE2",
  "#800080",
  "#6495ED",
  "#008B8B",
  "#C0C0C0",
  "#90EE90",
  "#B0E0E6",
  "#2F4F4F",
  "#FFC0CB",
  "#FFD700",
  "#DEB887",
  "#FF1493",
  "#FFEFD5",
  "#E9967A",
  "#0000CD",
  "#000000",
  "#FFE4B5",
  "#DC143C",
  "#0000FF",
  "#EEE8AA",
  "#BDB76B",
  "#FF0000",
  "#FFFFE0",
  "#DB7093",
  "#483D8B",
  "#1E90FF",
  "#FF00FF",
  "#808000",
  "#FFF0F5",
  "#7CFC00",
  "#A52A2A",
  "#FFDEAD",
  "#9ACD32",
  "#800000",
  "#FFE4E1",
  "#F8F8FF",
  "#F0FFF0",
  "#AFEEEE",
  "#ADFF2F",
  "#DAA520",
  "#F08080",
  "#00008B",
  "#8B008B",
  "#00FF00",
  "#BC8F8F",
  "#A9A9A9",
  "#7B68EE",
  "#87CEFA",
  "#000080",
  "#FFDAB9",
  "#FFFACD",
  "#F5F5F5",
  "#32CD32",
  "#FFE4C4",
  "#8B0000",
  "#FFFAFA",
  "#FFFFFF",
  "#FFF8DC",
  "#4682B4",
  "#A0522D",
  "#20B2AA",
  "#CD5C5C",
  "#FFFFF0",
  "#00FFFF",
  "#FFB6C1",
  "#F4A460",
  "#FF00FF",
  "#FFFAF0",
  "#FAFAD2",
  "#4B0082",
  "#D8BFD8",
  "#708090",
  "#FF8C00",
  "#F5FFFA",
  "#B8860B",
  "#778899",
  "#FF4500",
  "#00BFFF",
  "#FF7F50",
  "#9400D3",
  "#F5DEB3",
  "#C71585",
  "#696969",
  "#00CED1",
  "#DCDCDC",
  "#228B22",
  "#BA55D3",
  "#FFA500",
  "#F0E68C",
  "#00FFFF",
  "#6A5ACD",
  "#FAF0E6",
  "#556B2F",
  "#CD853F",
  "#EE82EE",
  "#F0FFFF",
  "#FF6347",
  "#9370DB",
  "#4169E1",
  "#F0F8FF",
  "#B0C4DE",
  "#ADD8E6",
  "#7B68EE",
];
